<footer class="d-flex align-items-center justify-content-center flex-column text-center">
  @if (cancellationPolicy) {
    <div class="mb-5">
      <cf-text size="sm" color="grey-70" class="text-break text-pre-line">
        <strong> {{ "meeting.cancellation_policy" | translate }}: </strong>
        {{ cancellationPolicy }}
      </cf-text>
    </div>
  }

  <div class="tw:w-full tw:flex tw:justify-between tw:items-center tw:md:items-start tw:md:flex-row! relative">
    <div class="tw:w-0 tw:md:w-20"></div>
    <div class="d-flex align-items-center tw:md:mb-4" *ngIf="showLogo">
      <span class="d-flex align-items-center">
        <cf-text size="sm">
          {{ "booking.forever_free_scheduling_with" | translate | translateCut: 0 }}
        </cf-text>
        <!-- <cf-icon icon="heart" class="ms-1"></cf-icon> -->
        <svg cfIcon="heart" class="tw:ml-1"></svg>
      </span>
      <span class="d-flex align-items-center">
        <cf-text class="ms-12" weight="500">{{
          "booking.forever_free_scheduling_with" | translate | translateCut: 1
        }}</cf-text>
        <a href="https://calfrenzy.com" target="_blank" cf-main-logo class="me-1"></a>
      </span>
    </div>
    <div class="tw:md:mt-2 tw:mb-4 tw:md:mb-0"><cf-language-picker placementToUse="top-end" /></div>
  </div>

  @if (!isPreview && showLogo) {
    <div class="text-center">
      <cf-text size="sm">
        {{ "booking.if_you_suspect_someone" | translate }}
        <a cf-link size="sm" href="mailto:abuse@calfrenzy.com">
          {{ "abuse@calfrenzy.com" }}
        </a>
      </cf-text>
    </div>
  }
</footer>
